import { ROOMS, ALL_ITEMS, CARRIED, CLUES, getItem, getClue, itemRoom, itemLines } from "@/game/rooms";

const roomLabel = (rid) => ROOMS[rid]?.name.replace("Main Floor — ", "") || rid;

const Entry = ({ tag, title, text, color, testid, onClick }) => (
  <li className="border-l-2 border-[#374151] hover:border-[#DC2626] hover:bg-[#1A1D27] pl-3 py-1.5 rise cursor-pointer transition-colors" data-testid={testid} onClick={onClick} title="Read again">
    <div className="flex items-center gap-2">
      {color && <span className="w-3 h-2.5 inline-block shrink-0" style={{ background: color, boxShadow: "0 0 0 1px #000" }} />}
      <span className="pixel-text text-lg text-[#F3F4F6] leading-none">{title}</span>
      <span className="pixel-text text-sm text-[#64748B] ml-auto shrink-0">{tag}</span>
    </div>
    <p className="pixel-text text-base text-[#9CA3AF] leading-snug mt-1">{text}</p>
  </li>
);

const Section = ({ label, count, total, children, empty, testid }) => (
  <div className="mb-6" data-testid={testid}>
    <div className="flex items-baseline justify-between mb-2">
      <p className="pixel-text text-base text-[#7DD3FC] tracking-widest">// {label}</p>
      <p className="pixel-text text-base text-[#F59E0B]" data-testid={`${testid}-count`}>{count} / {total}</p>
    </div>
    {count === 0 ? <p className="pixel-text text-base text-[#64748B] italic">{empty}</p> : <ul className="space-y-2">{children}</ul>}
  </div>
);

const LOGS = ALL_ITEMS.filter((i) => i.log);
const OBJECTS = ALL_ITEMS.filter((i) => !i.log);

export const Journal = ({ inventory, notes, onRead }) => {
  const found = inventory.map(getItem).filter(Boolean);
  const items = found.filter((i) => !i.log && !CARRIED.some((c) => c.id === i.id)), logs = found.filter((i) => i.log);
  const dana = notes.includes("ch3:start");
  const clues = (dana ? notes.slice(notes.indexOf("ch3:start")) : notes).map(getClue).filter(Boolean);
  return (
  <div className="max-h-[52vh] overflow-y-auto pr-2" data-testid="journal-panel">
    <p className="pixel-text text-base text-[#64748B] mb-4">Click any entry to read it again.</p>
    {!dana && <>
    <Section label="JOE'S KEEPSAKES" count={CARRIED.length - 1} total={CARRIED.length - 1} empty="" testid="journal-keepsakes">
      {CARRIED.filter((c) => c.id !== "flask").map((it) => (
        <Entry key={it.id} tag="Carried" title={it.name} text={it.desc} color={it.color} testid={`journal-keepsake-${it.id}`} onClick={() => onRead(itemLines(it))} />
      ))}
    </Section>
    <Section label="RESEARCHER LOGS" count={logs.length} total={LOGS.length} empty="Those who came before left notes somewhere in the cabin." testid="journal-logs">
      {logs.map((it) => (
        <Entry key={it.id} tag={roomLabel(itemRoom(it.id))} title={it.name} text={`"${it.desc}"`} color={it.color} testid={`journal-log-${it.id}`} onClick={() => onRead(itemLines(it))} />
      ))}
    </Section>
    <Section label="ITEMS FOUND" count={items.length} total={OBJECTS.length} empty="Nothing yet. Search the rooms." testid="journal-items">
      {items.map((it) => (
        <Entry key={it.id} tag={roomLabel(itemRoom(it.id))} title={it.name} text={it.desc} color={it.color} testid={`journal-item-${it.id}`} onClick={() => onRead(itemLines(it))} />
      ))}
    </Section>
    </>}
    <Section label={dana ? "CHAPTER 3 JOURNAL" : "CLUES & CONVERSATIONS"} count={clues.length} total={dana ? clues.length : CLUES.length} empty="Examine things that seem out of place." testid="journal-notes">
      {clues.map((c, i) => (
        <Entry key={c.id} tag={roomLabel(c.room)} title={c.title || `Note ${String(i + 1).padStart(2, "0")}`} text={c.text} testid={`journal-note-${i}`} onClick={() => onRead(c.lines)} />
      ))}
    </Section>
  </div>
  );
};
